(function () {
  function ora() {
    var d = new Date();
    return d.getHours() + ':' + String(d.getMinutes()).padStart(2, '0');
  }
  var SPUNTE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M2 13.5l3.6 3.6L13 9.4"/><path d="M10.2 16.6l.9.9L21 9.4"/></svg>';

  function avvia(chat) {
    if (chat.dataset.rfPronta) return;
    chat.dataset.rfPronta = '1';
    var corpo = chat.querySelector('[data-rf-corpo]');
    if (!corpo) return;
    var partenza = corpo.innerHTML;
    var bottoni = chat.querySelectorAll('.rf-pa[data-rf-d]');

    function giu() { corpo.scrollTop = corpo.scrollHeight; }

    function riga(html) {
      var r = document.createElement('div');
      r.className = 'rf-ch__g';
      r.innerHTML = html;
      corpo.appendChild(r);
      giu();
      return r;
    }

    bottoni.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        b.disabled = true;
        var d = b.getAttribute('data-rf-d');
        var r = b.getAttribute('data-rf-r');
        riga('<div class="rf-bo rf-bo--mia rf-bo--nuova">' + d + '<span class="rf-or">' + ora() + SPUNTE + '</span></div>');
        var att = null;
        var t1 = setTimeout(function () { att = riga('<span class="rf-scrive"><i></i><i></i><i></i></span>'); }, 320);
        setTimeout(function () {
          clearTimeout(t1);
          if (att) att.remove();
          riga('<div class="rf-bo rf-bo--sua rf-bo--nuova">' + r + '<span class="rf-or">' + ora() + '</span></div>');
        }, 1250);
      });
    });

    var ric = chat.querySelector('[data-rf-ric]');
    if (ric) ric.addEventListener('click', function () {
      corpo.innerHTML = partenza;
      bottoni.forEach(function (b) { b.disabled = false; });
    });
  }

  function tutte() { document.querySelectorAll('[data-rf-chat]').forEach(avvia); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tutte);
  else tutte();
  document.addEventListener('shopify:section:load', tutte);
})();
